import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
export const RemoveTitleFromMetaDescriptionView = ({
  auditResult,
  editorApi
}) => {
  const {
    track
  } = useTracker();
  const handleTrackAction = () => {
    track('Xray Panel', 'Xray Interaction', {
      action: 'clickedFixLink',
      recommendationType: SeoRecommendations.REMOVE_TITLE_FROM_META_DESCRIPTION
    });
  };
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "remove-title-from-meta-description-rec",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.REMOVE_TITLE_FROM_META_DESCRIPTION"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.REMOVE_TITLE_FROM_META_DESCRIPTION"
    }),
    status: auditResult.status,
    action: editorApi.removeTitleFromMetaDescription,
    actionButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.actions.REMOVE_TITLE_FROM_META_DESCRIPTION"
    }),
    onTrackAction: handleTrackAction
  });
};